import React from 'react';
import { Activity, Brain, Compass } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = [{
    title: 'CORPUL',
    subtitle: 'OBOSEALĂ · SIMPTOME · CONFUZIE',
    text: 'Analizele ies bine, dar tu nu te simți bine. Te trezești epuizat/ă, mergi pe pilot automat și ignori semnalele corpului pentru că nu ai timp, nu știi ce înseamnă sau ți-e frică să afli.',
    icon: Activity
  }, {
    title: 'MINTEA',
    subtitle: 'STRES · VINOVĂȚIE · EPUIZARE EMOȚIONALĂ',
    text: 'Dai totul celor din jur și nu mai rămâne nimic pentru tine. Trăiești cu vina că nu ești suficient/ă ca părinte, ca partener, ca om, deși faci enorm în fiecare zi.',
    icon: Brain
  }, {
    title: 'DIRECȚIA',
    subtitle: 'PIERDUT · FĂRĂ HARTĂ · FĂRĂ SENS',
    text: 'Ai bifat tot ce trebuia în viață, dar simți că lipsește ceva esențial. Nu știi dacă ai nevoie de un medic, un terapeut sau altceva. Te-ai săturat să cauți răspunsuri fără să găsești claritate.',
    icon: Compass
  }];
  return <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-181" data-mp="swuo3u4nitf2">
      <div className="max-w-7xl mx-auto" data-id="element-182" data-mp="wx4rr04z17qr">
        <div className="text-center mb-16" data-id="element-183" data-mp="wy6ei1vcniob">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-4" data-id="element-184" data-mp="11uepr46ferq7">
            Te regăsești în cel puțin una din acestea?
          </h2>
          <div className="w-16 h-0.5 bg-primary mx-auto rounded-full" data-id="element-185" data-mp="16s6k04ujmpxk"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-186" data-mp="1brjcb546op7j">
          {painPoints.map((point, index) => {
          const Icon = point.icon;
          return <div key={index} className="bg-soft rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center" data-id="element-187" data-mp="1kmhbuv1u707u" data-mpi={index}>
                {/* Professional Vector Icon */}
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary to-medium text-white flex items-center justify-center mb-6 shadow-lg" data-id="element-188" data-mp="1ziovnu9c1zml">
                  <Icon size={40} strokeWidth={1.5} data-id="element-189" data-mp="19syk12p8es8u" />
                </div>

                <h3 className="text-2xl font-bold text-primary mb-2" data-id="element-190" data-mp="14xj84gasb6f2">
                  {point.title}
                </h3>
                <p className="text-xs font-bold text-medium tracking-wider mb-6 uppercase" data-id="element-191" data-mp="1jmyy3u2hr7tp">
                  {point.subtitle}
                </p>
                <p className="text-body leading-relaxed" data-id="element-192" data-mp="1skrdszc4khhm">{point.text}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}